import { CreationController } from "../CreationPage/CreationController";
import { DMCRectangle } from "../CreationPage/KObjects/DMCRectangle";
import { DMCText } from "../CreationPage/KObjects/DMCText";
import { DMCImage } from "../CreationPage/KObjects/DMCImage";
import { DMCVideo } from "../CreationPage/KObjects/DMCVideo";
import { DMCScrolling } from "../CreationPage/KObjects/DMCScrolling";
import { DMCCalendar } from "../CreationPage/KObjects/DMCCalendar";
import { DMCButton } from "../CreationPage/KObjects/DMCButton";
import { DMCWeb } from "../CreationPage/KObjects/DMCWeb";
import { DMCWeather } from "../CreationPage/KObjects/DMCWeather";

// Tools
const ft = require("../Tools/FileTools");

/**
 * This class is made to read the project associated. It manages correctly the path and return the necessary object to load it into a stage.
 */
export class ScheduleReader {
  constructor(schedule, projectPath = null, userData, preview = false) {
    this.scheduleName = schedule.projectData.name;
    this.schedule = schedule;
    this.controllerProject = null;
    this.preview = preview;
    this.projectPath = projectPath;
    this.creationControllerJSON = null;
    this.readingProjectsPath = "./temp/readingDirectory/projects/"; //DEFAULT PATH
    this.readingPreviewPath = "./temp/readingPreview/";

    if (userData !== undefined) {
      this.readingPreviewPath = "./temp/" + userData.socId + "/" + userData.userId + "/readingPreview/";

      if (this.preview) {
        this.projectPath = projectPath.replace("./mediacenter/", this.readingPreviewPath);
      }
    }
  }

  /**
   * Create a new konva element according to what is the type of the DMCObject given in parameter.
   * Add the konva property directly into the creationController
   * @param {DMCObjectJSON} DMCObject
   * @param {CreationController} creationController
   * @param {*} incorporate
   */
  createNewElement(DMCObject, creationController, incorporate = true) {
    return new Promise((resolve, reject) => {
      const type = DMCObject.name.split(" ")[0];
      let object;

      switch (type) {
        case "Rect":
          object = new DMCRectangle().load(creationController, DMCObject, incorporate);
          break;
        case "Button":
          object = new DMCButton().load(creationController, DMCObject, incorporate);
          break;
        case "Text":
          object = new DMCText().load(creationController, DMCObject, incorporate);
          break;
        case "Image":
          object = new DMCImage().load(creationController, DMCObject, incorporate);
          break;
        case "pdf":
          object = new DMCImage().load(creationController, DMCObject, incorporate);
          break;
        case "Video":
          object = new DMCVideo().load(creationController, DMCObject, incorporate);
          break;
        case "Scrolling":
          object = new DMCScrolling().load(creationController, DMCObject, incorporate);
          break;
        case "rss":
          object = new DMCScrolling().load(creationController, DMCObject, incorporate);
          break;
        case "Calendar":
          object = new DMCCalendar().load(creationController, DMCObject, incorporate);
          break;
        case "Web":
          object = new DMCWeb().load(creationController, DMCObject, incorporate);
          break;
        case "Weather":
          object = new DMCWeather().load(creationController, DMCObject, incorporate);
          break;

        default:
          return reject("Error on schedule reader create new element : " + DMCObject);
      }

      return resolve(object);
    });
  }

  /**
   * Return true if the current date match with the schedule, otherwise return false;
   */
  doIRead() {
    return this.schedule.doIPlay();
  }

  /**
   * TODO: Fait des choses mais on sait pas vraiment quoi
   * TODO: TOUT REFAIRE
   */
  loadCompiledProjectPath(projectPath = null) {
    const projectDir = ft.getFileNameFromPath(this.schedule.projectData.name);
    let path = this.readingProjectsPath;

    if (this.preview) {
      path = this.readingPreviewPath;
    }

    if (projectPath != null) {
      this.projectDirectory = projectPath;
      this.projectPath = projectPath + "/project.json";
    } else {
      this.readProjectController();
      this.projectDirectory = projectDir;
      this.projectPath = path + projectDir + "/project.json";
    }
  }

  /**
   * Read the project file and get the creation controller from it
   */
  readProjectController() {
    ft.read(this.projectPath)
      .then((content) => {
        this.creationControllerJSON = content;
        this.load();
      })
      .catch((err) => {
        this.creationControllerJSON = null;
        console.error(err);
      });
  }

  /**
   * Load the project into the creation controller and creates all the Konva object.
   */
  load() {
    if (this.creationControllerJSON != null) {
      if (typeof this.creationControllerJSON !== "object") {
        this.creationControllerJSON = JSON.parse(this.creationControllerJSON);
      }

      this.controllerProject = new CreationController(null, this.creationControllerJSON.projectSize, null);
      // // WE DEFINE PROJECT SIZE
      for (let element of Object.values(this.creationControllerJSON.elements)) {
        // THIS SUB THE ./temp TO FIND THE CORRECT SOURCE WHILE LOADING IMAGE/VIDEO
        element.projectPath = this.projectDirectory.replace("./temp", "") + "/";

        this.createNewElement(element, this.controllerProject, false)
          .then((object) => {
            for (let anim of Object.values(this.creationControllerJSON.refreshAnimation)) {
              if (anim.id == object.name) {
                object.loadAnimation(anim.animation, this.creationControllerJSON.projectSize);
              }
            }

            this.controllerProject.elements[object.name] = object;
          })
          .catch((err) => {
            console.error(err);
          });
      }

      this.controllerProject.elementsNumber = this.creationControllerJSON.elementsNumber;
    } else {
      console.warn("Error on load schedule reader: No creation controller json defined");
    }
  }
}
